const config = {
    API_URL: `https://wix-backend.zoorix.com/api/v1`,
};

export default config;